import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})


export class ApiserviceService {

  constructor( private _HttpClient:HttpClient) {

    }


pageNumber:number=1;


  getTrendMovies():Observable<any>
  {
    return this._HttpClient.get(`https://api.themoviedb.org/3/movie/popular?api_key=361608c63a85a9b1a1d2432226f9dcd2&language=en-US&page=1`)
  }
    
  getMovies(pageNumber:any):Observable<any>
    {
      return this._HttpClient.get(`https://api.themoviedb.org/3/movie/now_playing?api_key=361608c63a85a9b1a1d2432226f9dcd2&language=en-US&page=`+pageNumber)
    }

    
    getMovieDetails(id:any):Observable<object>
    {
      return this._HttpClient.get(`https://api.themoviedb.org/3/movie/`+id+`?api_key=361608c63a85a9b1a1d2432226f9dcd2&language=en-US`)
    }


  getYoutubeLink(id:any):Observable<any>{

    return this._HttpClient.get('https://api.themoviedb.org/3/movie/'+id+'/videos?api_key=361608c63a85a9b1a1d2432226f9dcd2&language=en-US')
  }

    
  getMovieCast(id:any):Observable<any>{

    return this._HttpClient.get('https://api.themoviedb.org/3/movie/'+id+'/credits?api_key=866cd3a065ef9304a549f1d65e494940&language=en-US')
  }

// tv 

getTvShow(pageNumber:any):Observable<any>
{
  return this._HttpClient.get(`https://api.themoviedb.org/3/tv/popular?api_key=361608c63a85a9b1a1d2432226f9dcd2&language=en-US&page=`+pageNumber)
}


getTvShowDetails(id:any):Observable<object>
{
  return this._HttpClient.get(`https://api.themoviedb.org/3/tv/`+id+`?api_key=361608c63a85a9b1a1d2432226f9dcd2&language=en-US`)
}

getTvCast(id:any):Observable<any>{

  return this._HttpClient.get('https://api.themoviedb.org/3/tv/'+id+'/credits?api_key=866cd3a065ef9304a549f1d65e494940&language=en-US')
}



getTvYoutubeLink(id:any):Observable<any>{

  return this._HttpClient.get('https://api.themoviedb.org/3/tv/'+id+'/videos?api_key=361608c63a85a9b1a1d2432226f9dcd2&language=en-US')
}


//search

searchmovie(query:any):Observable<any>{

  return this._HttpClient.get(`https://api.themoviedb.org/3/search/movie?api_key=361608c63a85a9b1a1d2432226f9dcd2&language=en-US&query=`+query+`&page=1&include_adult=false`)
}


searchTv(query:any):Observable<any>{

  return this._HttpClient.get(`https://api.themoviedb.org/3/search/tv?api_key=361608c63a85a9b1a1d2432226f9dcd2&language=en-US&page=1&query=`+query+`&include_adult=false`)
}





}
